import React from 'react';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Accordion Header
 * @param className {string} Additionnal CSS Classes
 * @param toggle {boolean} Toggle Header
 * @param toggleBox {string} toggle direction
 * @param toggleBoxClass {string} Additionnal Classes for toggle box
 * @param children {React.ReactNode}
 * @param toggleClass
 * @param testId
 * @param onClick
 * @param others
 */
const AccordionHeader = ({ children, className, toggle, toggleBox, toggleBoxClass, toggleClass, testId, dataId, active, disabled, onClick, ...others }) => {
    const { styled } = useTrilogyContext();
    const toggleBtnClasses = hashClass(styled, clsx('toggle button is-bordered is-shadowless', toggleBoxClass));
    return (React.createElement("label", { onClick: onClick, "data-accordion-header": true, className: hashClass(styled, clsx('accordion-header', className)), "aria-label": 'toggle', ...others, "data-testid": testId, htmlFor: `toggle_${dataId}` },
        toggleBox === 'left' && React.createElement("div", { className: toggleBtnClasses }),
        children,
        toggle && React.createElement("div", { className: hashClass(styled, clsx('toggle', toggleClass)) }),
        toggleBox === 'right' && React.createElement("div", { className: toggleBtnClasses })));
};
export default AccordionHeader;
//# sourceMappingURL=AccordionHeader.js.map